export const BackEndpath = "https://lab.oretasg.com";
export const MicrosoftAuthUri = "https://lab.oretasg.com/login";

